<template>
  <div class="min-w-[920px] text-sm lg:text-base">
    <div class="bg-grey-300 grid grid-cols-10 px-6 py-3 font-semibold">
      <div class="col-span-4">Products</div>
      <div class="col-span-6 grid grid-cols-6 gap-3">
        <div v-for="item in headers" :key="item.title" :class="item.class">{{
          item.title
        }}</div>
      </div>
    </div>
    <div class="flex flex-col gap-8 p-6 text-sm lg:text-base">
      <PriceAssessmentsSummaryTableIndexSection
        v-for="index in summary"
        :key="index.product"
        :index-name="index.product"
        :index-data="index.data"
        :slug="slug"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TGeneral } from '~/src/types/common'

const props = defineProps<{
  summary: TGeneral[]
  slug: string
}>()

const marketWith2WK = ['lithium', 'nickel', 'recycling']
const marketWith1WK = ['cobalt']
const is2WK = computed(() => marketWith2WK.includes(props.slug))
const is1WK = computed(() => marketWith1WK.includes(props.slug))
const headers = computed(() => {
  const period = is2WK.value ? '2WK' : is1WK.value ? '1WK' : '1M'

  return [
    { title: period, class: '' },
    { title: 'YOY', class: '' },
    { title: 'YTD', class: '' },
    { title: 'Current', class: '' },
    { title: 'Previous', class: '' },
    { title: 'Share', class: 'text-right' },
  ]
})
</script>
